class Dropzone {
	constructor(config) {
		this.config = Object.assign({
			scope: '',
			input: '',
		}, config);

		this.init();
	}

	init() {
		let $dropzone = $(this.config.scope);
		let $input = $(this.config.input);

		$dropzone.off('custom-dropzone')
			.on("dragover.custom-dropzone", this.onDragover.bind(this))
			.on("dragleave.custom-dropzone", this.onDragleave.bind(this))
			.on("drop.custom-dropzone", this.onDrop.bind(this))
			.on("click.custom-dropzone", this.onClick.bind(this));

		$input
			.off('custom-dropzone')
			.on("change.custom-dropzone", this.onChange.bind(this));
	}

	onDragover(event) {
		event.preventDefault();
		this.config.scope.classList.add("dragover");
	}

	onDragleave() {
		this.config.scope.classList.remove("dragover")
	}

	onDrop(event) {
		event.preventDefault();
		let datatransfer = event.dataTransfer ?? event.originalEvent.dataTransfer;
		this.config.scope.classList.remove("dragover");
		this.handleFiles(datatransfer.files);
	}

	onClick(event) {
		let $target = $(event.target);
		if($target.is('a') || $target.closest('a').length > 0) {
			return;
		}
		this.config.input.click()
	}

	onChange(event) {
		this.handleFiles(this.config.input.files)
	}

	handleFiles(files) {
		$(this.config.scope).trigger('fileAdded', {
			files: files
		});
	}
}

export default Dropzone;